import 'SRC/js/accordion.js';
import 'SRC/js/vendor/lightbox.min.js';
import 'SRC/js/gallery-lightbox.js';
import 'SRC/js/navigation.js';
import 'SRC/js/outdated-browsers.js';
import 'SRC/js/search.js';
import 'SRC/js/slideshow.js';